import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";

// Helper function to create resource URL
const getResourceUrl = (url) => `/resource/${encodeURIComponent(url)}`;

export default function Resources() {
  useEffect(() => {
    document.title = "TOC > Resources";
  }, []);

  return (
    <div className="w-full max-w-full sm:max-w-[500px] min-h-screen md:min-h-[550px] flex-col bg-pink-50 flex items-center mx-auto">
      <Header />

      <div className="w-full px-2 sm:px-4 py-3 sm:py-6 flex-1">
        <div className="bg-[#f3ebe3] rounded-md shadow-xl border border-gray-300 overflow-hidden">
          {/* Title with Back Button */}
          <div className="w-full flex items-center justify-between px-3 pt-4 pb-3">
            <Link
              to="/tax-help"
              className="w-10 h-10 text-[#f7adc4] rounded-full font-semibold transition transform hover:-translate-x-0.5 hover:scale-[1.02] active:scale-[0.98] grid place-items-center flex-shrink-0"
            >
              <svg
                className="h-6 w-6"
                viewBox="0 0 20 20"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4A1 1 0 018.707 6.293L6.414 8.586H17a1 1 0 110 2H6.414l2.293 2.293a1 1 0 010 1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </Link>
            <h2 className="font-semibold text-center text-lg sm:text-xl md:text-2xl tracking-wide flex-1">
              Resources
            </h2>
            <div className="w-10"></div>
          </div>

          {/* Content */}
          <div className="p-4 sm:p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          {/* Tax Education Button */}
          <div className="bg-white border border-gray-300 rounded-md shadow-sm overflow-hidden">
            <div className="bg-[#f7adc4] text-white px-4 py-3">
              <h3 className="font-semibold text-base sm:text-lg">Tax Education</h3>
            </div>
            <div className="p-4 space-y-2">
              <Link
                to={getResourceUrl("https://example.com/self-employment-tax-101")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Self-employment Tax 101
              </Link>
              <Link
                to={getResourceUrl("https://example.com/bookkeeping-organization")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Bookkeeping + Organization
              </Link>
              <Link
                to={getResourceUrl("https://example.com/llcs")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                LLCs
              </Link>
              <Link
                to={getResourceUrl("https://example.com/irs")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                IRS
              </Link>
              <Link
                to={getResourceUrl("https://example.com/faq")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                FAQ
              </Link>
            </div>
          </div>

          {/* Write Off Guide Button */}
          <div className="bg-white border border-gray-300 rounded-md shadow-sm overflow-hidden">
            <div className="bg-[#f7adc4] text-white px-4 py-3">
              <h3 className="font-semibold text-base sm:text-lg">Write Off Guide</h3>
            </div>
            <div className="p-4 space-y-2">
              <Link
                to={getResourceUrl("https://www.irs.gov/businesses/small-businesses-self-employed/deducting-business-expenses")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Business Expense Deductions
              </Link>
              <Link
                to={getResourceUrl("https://www.irs.gov/publications/p535")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Business Expenses Publication
              </Link>
              <Link
                to={getResourceUrl("https://www.irs.gov/businesses/small-businesses-self-employed/home-office-deduction")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Home Office Deduction Guide
              </Link>
              <Link
                to={getResourceUrl("https://www.irs.gov/businesses/small-businesses-self-employed/travel-entertainment-gift-and-car-expenses")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Travel & Entertainment Expenses
              </Link>
            </div>
          </div>

          {/* Work with Us Button */}
          <div className="bg-white border border-gray-300 rounded-md shadow-sm overflow-hidden">
            <div className="bg-[#f7adc4] text-white px-4 py-3">
              <h3 className="font-semibold text-base sm:text-lg">Work with Us</h3>
            </div>
            <div className="p-4 space-y-2">
              <Link
                to={getResourceUrl("https://example.com/book-a-call")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Book a call
              </Link>
              <Link
                to={getResourceUrl("https://example.com/tax-client-application")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Tax Client Application
              </Link>
              <Link
                to={getResourceUrl("https://example.com/bookkeeping-application")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Bookkeeping Application
              </Link>
              <Link
                to={getResourceUrl("https://example.com/payroll-referral")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Payroll Referral
              </Link>
              <Link
                to={getResourceUrl("https://example.com/life-insurance")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Life Insurance
              </Link>
              <Link
                to={getResourceUrl("https://example.com/health-insurance")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Health Insurance
              </Link>
              <Link
                to={getResourceUrl("https://example.com/wealth-management")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Wealth Management
              </Link>
              <Link
                to={getResourceUrl("https://example.com/credit-cards-banks")}
                className="block text-sm text-[#f7adc4] hover:text-[#f49fb8] hover:underline"
              >
                Credit Cards + Banks
              </Link>
            </div>
          </div>

          {/* Already a Client? Button */}
          <div className="bg-white border border-gray-300 rounded-md shadow-sm">
            <div className="bg-[#f7adc4] text-white px-4 py-3">
              <h3 className="font-semibold text-base sm:text-lg">Already a Client?</h3>
            </div>
            <div className="p-4 space-y-4">
              {/* Login Form */}
              <form className="w-full">
                <div className="space-y-0">
                  <input
                    type="email"
                    placeholder="Email"
                    required
                    className="w-full border border-gray-300 bg-white rounded-t-md rounded-b-none px-3 py-2.5 text-sm text-gray-800 placeholder:text-gray-500 focus:ring-2 focus:ring-[#f7adc4] outline-none transition-all border-b-0"
                  />
                  <input
                    type="password"
                    placeholder="Password"
                    required
                    className="w-full border border-gray-300 bg-white rounded-b-md rounded-t-none px-3 py-2.5 text-sm text-gray-800 placeholder:text-gray-500 focus:ring-2 focus:ring-[#f7adc4] outline-none transition-all"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-[#f7adc4] text-white tracking-wider rounded-full text-xs font-semibold py-2.5 hover:bg-[#f49fb8] transition-colors mt-2"
                >
                  LOGIN
                </button>
                <div className="border-t border-gray-300 pt-2 mt-2"></div>
              </form>

              {/* Informational Text */}
              <div className="text-xs text-gray-600 leading-relaxed space-y-2 pt-2">
                <p className="text-gray-600">
                  * Must be an existing client of Prisma Tax Group in order to access the Portal. Subscription to the Only Consultant app does not make you a Prisma Tax Group client.
                </p>
                <p className="text-gray-600">
                  Please check "Work with Us" section in order to become a client of Prisma Tax Group.
                </p>
              </div>
            </div>
          </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="w-full bg-[#f7adc4] text-white text-center flex justify-center items-center px-4 py-2 mt-auto">
        <img src="/1.png" alt="Logo" className="h-auto w-16 sm:w-20" />
      </div>
    </div>
  );
}
